import React from "react";
import {UseFormReturn} from "react-hook-form";
import {CreateAndEditUserProps, CreateAndEditUserState} from "./models";
import {withUseFormHook} from "@sinossi/mates-react-library";
import * as Yup from "yup";
import {
    Box,
    Button,
    Grid,
} from "@mui/material";
import {t, Trans} from "@lingui/macro";
import { Sex, UserRole } from "models";
import { ZPlayDatePicker, ZPlaySelect } from "commons/fields";
import ZplayFormField from "commons/fields/zplay-form-field";
import { UpdateUserRequest } from "models/request";


const CreateAndEditUserFormSchema = Yup.object().shape({
});

class CreateAndEditUser extends React.Component<CreateAndEditUserProps & UseFormReturn, CreateAndEditUserState> {

    constructor(props: any) {
        super(props);

        this.state={
            formFlag: false,
        }
    }

    componentDidMount() {

        this.props.setValue('newsletterConsent', false);

        if(this.props.user){
            this.setFormValues();
        }

        this.setState(() => ({formFlag: true}));
    }

    private setFormValues(){
        this.props.setValue('name', this.props.user!.name);
        this.props.setValue('surname', this.props.user!.surname);
        this.props.setValue('email', this.props.user!.email);
        this.props.setValue('birthday', this.props.user!.birthDate);
        this.props.setValue('sex', this.props.user!.sex);
        this.props.setValue('role', this.props.user!.role);
    }

    private submitForm = (values: any) => {

        let request: UpdateUserRequest = {
            name: values.name,
            surname: values.surname,
            email: values.email,
            birthday: values.birthday,
            sex: values.sex,
            role: values.role,
            newsletterConsent: false,
        }

        this.props.onSubmit(request);    
    };

    render() {

        const hiddenRole = this.props.user?.role === UserRole.END_USER || this.props.user?.role === UserRole.GUEST;

        return (
            <Box>
                {this.state.formFlag && <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <Box
                        p={3}
                        borderRadius="5px"
                        bgcolor={process.env.REACT_APP_THIRD_COLOR}>
                        <Grid container columnSpacing={3} rowSpacing={1}>
                            <Grid item xs={12} md={6}>
                                <ZplayFormField
                                    label={t({
                                        id: "caeu-name",
                                        message: "Nome"
                                    })}
                                    name='name'
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                    required={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <ZplayFormField
                                    label={t({
                                        id: "caeu-surname",
                                        message: "Cognome"
                                    })}
                                    name='surname'
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                    required={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <ZplayFormField
                                    label={t({
                                        id: "caeu-email",
                                        message: "Email"
                                    })}
                                    name='email'
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                    required={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <ZPlayDatePicker
                                    label={t({
                                        id: "caeu-birth-date",
                                        message: "Data di nascita",
                                    })}
                                    name={`birthday`}
                                    formState={this.props.formState}
                                    control={this.props.control}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <ZPlaySelect
                                    name="sex"
                                    label={t({
                                        id: "caeu-sex",
                                        message: "Sesso"
                                    })}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}>
                                        <option value={Sex.F}>Femmmina</option>
                                        <option value={Sex.M}>Maschio</option>
                                        <option value={Sex.O}>Altro</option>
                                </ZPlaySelect>
                            </Grid>
                            {!hiddenRole && <Grid item xs={12} md={4} mt={2}>
                                <ZPlaySelect
                                    name="role"
                                    label={t({
                                        id: "caeu-role",
                                        message: "Ruolo"
                                    })}
                                    required={true}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    disabled={this.props.user?.role === UserRole.END_USER || this.props.user?.role === UserRole.GUEST}
                                    trigger={this.props.trigger}>
                                        <option value={UserRole.ADMIN}>Admin</option>
                                        <option value={UserRole.ANALYST}>Analista</option>
                                        <option value={UserRole.PRODUCER}>Produttore</option>
                                        <option value={UserRole.CHIEF_PRODUCER}>Capo produttore</option>
                                </ZPlaySelect>
                            </Grid>}
                        </Grid>
                    </Box>

                    <Grid item
                          xs={12}
                          mt={2}
                          textAlign={"right"}>
                        <Button
                            variant="contained"
                            color={"primary"}
                            disabled={this.props.formState.isSubmitting}
                            type="submit">
                            {this.props.user?
                                <Trans id="caeu-submit-edit-button">Modifica</Trans> :
                                <Trans id="caeu-submit-create-button">Crea</Trans>}
                        </Button>
                    </Grid>
                </form>}
            </Box>
        );
    }


}


export default withUseFormHook<{}>(CreateAndEditUser, CreateAndEditUserFormSchema, {});